import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, catchError, of, switchMap } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Si la autenticación no está inicializada, inicializarla primero
  if (!authService.authInitialized) {
    return authService.initializeAuth().pipe(
      switchMap(() => {
        if (authService.isAuthenticated()) {
          return of(true);
        }
        return of(router.parseUrl('/auth'));
      }),
      catchError(() => {
        return of(router.parseUrl('/auth'));
      })
    );
  }

  // Si ya está inicializada y tenemos usuario, permitir acceso
  if (authService.isAuthenticated()) {
    return true;
  }

  // Si no hay usuario, intentar verificar una vez más con el servidor
  return authService.refreshUserData().pipe(
    map(user => {
      if (user && authService.isAuthenticated()) {
        return true;
      }
      return router.parseUrl('/auth');
    }),
    catchError(() => {
      return of(router.parseUrl('/auth'));
    })
  );
};
